import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  TablePanel, Alert, Button,
} from 'components/common'
import { varLabel, varValue } from 'common/var'
import { asDate, asPrice } from 'utils/text'
import { callGetApiWithAuth } from 'utils/api'
import OrderDetailModal from './OrderDetailModal'

export default function NegativeBonusSubPage() {
  const [amount, setAmount] = useState(0)
  const [tableData, setTableData] = useState([])
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15, 
    total: 0
  })
  const [isLoading, setIsLoading] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(undefined)
  const [loadingOrderId, setLoadingOrderId] = useState(null)

  const onGetTableData = (res) => {
    setTableData(res.data.histories.data)
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.histories.current_page,
      total: res.data.histories.total
    })
    setAmount(res.data.amount)
    setIsLoading(false)
  }
  const onFailTableData = () => {
    setIsLoading(false)
  }
  const loadTableData = (paginationParam0) => {
    setIsLoading(true)
    const params = {
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    }
    const q = Object.keys(params).map(k=>k+'='+params[k]).join('&')
    callGetApiWithAuth(`earning/negative_bonus/list?${q}`, 
      onGetTableData, onFailTableData
    )
  }

  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page
    }
    loadTableData(paginationParam0)
  }

  const onGetOrderDetails = (res) => {
    setSelectedOrder(res.data)
    setLoadingOrderId(null)
  }

  const onFailOrderDetails = () => {
    console.log('Failed to fetch order details')
    setLoadingOrderId(null)
  }

  const handleDetailClick = (comment, recordId) => {
    // Extract user UUID and order number from comment like "Clawback $5.01 (Source User: 2297684, Order: 91211272)"
    const userMatch = comment.match(/Source User:\s*(\d+)/)
    const orderMatch = comment.match(/Order:\s*(\d+)/)
    
    if (userMatch && userMatch[1] && orderMatch && orderMatch[1]) {
      const uuid = userMatch[1]
      const orderNumber = orderMatch[1]
      console.log('User UUID:', uuid)
      console.log('Order Number:', orderNumber)
      // Set loading state for this specific button
      setLoadingOrderId(recordId)
      // Fetch order details from API
      callGetApiWithAuth(
        `earning/${uuid}/order/${orderNumber}`,
        onGetOrderDetails,
        onFailOrderDetails
      )
    } else {
      console.log('User UUID or Order number not found in comment:', comment)
    }
  }

  useEffect(() => {
    loadTableData(paginationParam)
  }, [])

  return (
    <Wrapper>
      <TablePanel
        title={
          <div className='title'>
            Commission Adjustments&nbsp;
            <div className='subtitle'>
              (Current Amount:&nbsp;{amount>0?'-'+asPrice(amount):asPrice(amount)})
            </div>
            <Alert 
              message={<span>
                When calculating your commissions, we adjust any refunds, returns, or chargebacks that occur in your organization. These adjustments are subtracted out of your weekly or monthly earnings.
              </span>}
              type='info'
              showIcon
            />
          </div>
        }
        data={tableData}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        loading={isLoading}
        columns={[
          {
            title: 'Date',
            render: (_, record) => (
              <span>{asDate(record.created_at)}</span>
            )
          },
          {
            title: 'Amount',
            render: (_, record) => (
              <span>
                {asPrice(record.amount)}
              </span>
            )
          },
          {
            title: 'Type',
            render: (_, record) => (
              <span>
                {varLabel('userMinusBonusHistory.type', record.type)}
              </span>
            )
          },
          {
            title: 'Note',
            render: (_, record) => (
              <span>{record.comment}</span>
            )
          },
          {
            title: 'Action',
            render: (_, record) => (
              <>
                {record.type === varValue('userMinusBonusHistory.type', 'refund') && (
                  <Button 
                    onClick={() => handleDetailClick(record.comment, record.id)}
                    size="small"
                    loading={loadingOrderId === record.id}
                    disabled={loadingOrderId === record.id}
                  >
                    Detail
                  </Button>
                )}
              </>
            )
          }
        ]}
      />
      {selectedOrder && (
        <OrderDetailModal 
          selectedOrder={selectedOrder}
          setSelectedOrder={setSelectedOrder}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .subtitle {
    font-size: 14px;
    color: ${props=>props.theme.palette.secondaryText};
  }
`
